import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

import { Order } from '../interface';
import { OrderProduct } from '../orderProductsLoader/interface';

export type _PreOrderProductVar = {
  price: number;
  amount: number;
  token: string;
  data: string;
  product_type: string;
};

export type _PreOrderMutationVar = {
  pre_order_products: _PreOrderProductVar[];
  currency_id: number;
  language_id: number;
};

/** Приведение продукта к формату Pre_Order_Product_Complete_Data. */
export const toPreOrderProductVar = (product: OrderProduct): _PreOrderProductVar => ({
  product_type: product.product_type,
  price: product.price,
  amount: product.amount,
  data: product.data,
  token: product.token,
});

// Мутация на создание предзаказа
export class CreatePreOrderMutation
  implements GraphQLQuery<{ preOrder: _PreOrderMutationVar; bitrixUserId?: number }>
{
  readonly query: any;

  readonly variables: { preOrder: _PreOrderMutationVar; bitrixUserId?: number };

  constructor(preOrder: Order, bitrixUserId?: number) {
    this.variables = {
      preOrder: {
        currency_id: Number(preOrder.currency_id),
        language_id: Number(preOrder.language_id),
        pre_order_products: preOrder.products.map(toPreOrderProductVar),
      },
      bitrixUserId,
    };

    this.query = gql`
      mutation __CREATE_PRE_ORDER__($preOrder: Pre_Order_Complete_Data!, $bitrixUserId: Int) {
        data: pre_order_create(pre_order: $preOrder, bitrix_user_id: $bitrixUserId) {
          currency_id
          currency_nominal
          currency_rate
          date
          id
          language_id
          order_price
          pre_order_products {
            amount
            data
            id
            pre_order_id
            price
            product_type
            token
          }
        }
      }
    `;
  }
}
